import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import {
  IncentiveOffer,
  IncentiveOfferType,
} from 'modules/incentivesMarket/types';
import {
  IncentiveOfferSortOption,
  incentiveOffersSortOptions,
} from '../constants/incentiveOffersSortOptions';
import IncentiveOfferRow from './IncentiveOfferRow';

type IncentiveOffersSectionProps = {
  type: IncentiveOfferType;
  offers: IncentiveOffer[];
  sortBy: IncentiveOfferSortOption;
  onSortChange: (sortBy: IncentiveOfferSortOption) => void;
  onViewDetail: (offerId: string) => void;
  societyId: string;
  showPrices?: boolean;
};

const IncentiveOffersSection: FC<IncentiveOffersSectionProps> = ({
  type,
  offers,
  sortBy,
  onSortChange,
  onViewDetail,
  societyId,
  showPrices = true,
}) => {
  const { t } = useTranslate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const isSellOffer = type === 'SELL';
  const title = isSellOffer ? t('SellOffers') : t('BuyOffers');
  const viewAllPath = isSellOffer
    ? `/trading-offers-sell/${societyId}`
    : `/trading-offers-buy/${societyId}`;

  const currentSortLabel = incentiveOffersSortOptions.find(
    (opt) => opt.value === sortBy
  )?.label;

  return (
    <div className="nk-block nk-block-lg">
      {/* <div className="nk-block-head-sm">
        <div className="nk-block-head-content d-flex flex-wrap justify-content-between align-items-center g-2">
          <h5 className="nk-block-title mb-0">
            {title} <span className="count text-base">({offers.length})</span>
          </h5>
          <Link to={viewAllPath} className="link link-soft is-disable">
            {t('ViewAll')}
          </Link>
        </div>
      </div> */}

      <div
        className="nk-block-head-content mb-4 d-flex align-items-center gap-2 flex-wrap"
        style={{ marginTop: '-0.5rem' }}
      >
        <span className="text-soft small">{t('SortBy')}:</span>
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle
            tag="button"
            className="btn btn-sm btn-outline-light dropdown-toggle"
          >
            {t(currentSortLabel || 'Price')}
          </DropdownToggle>
          <DropdownMenu end>
            {incentiveOffersSortOptions.map((option) => (
              <DropdownItem
                key={option.value}
                active={sortBy === option.value}
                onClick={() => onSortChange(option.value)}
              >
                {t(option.label)}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      {offers.length > 0 ? (
        <div
          className={`incentive-offer-list ${
            showPrices
              ? 'incentive-offer-list--with-prices'
              : 'incentive-offer-list--without-prices'
          }`}
        >
          {offers.map((offer) => (
            <IncentiveOfferRow
              key={offer._id}
              offer={offer}
              onViewDetail={onViewDetail}
              showPrices={showPrices}
            />
          ))}
        </div>
      ) : (
        <EmptyStateCard
          mainMessage={isSellOffer ? t('NoSellOffersYet') : t('NoBuyOffersYet')}
          centered
        />
      )}
    </div>
  );
};

export default IncentiveOffersSection;
